// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/holding-position-markings.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/holding-position-markings/holding-position-markings.js';

mount([g0]);
